
  import { defineComponent } from "vue";

  import BaseProcessComponentV2 from "@/components/processComponents/v2/BaseProcessComponentV2.vue";

  export default defineComponent({
    name: "SimpleContainer",

    extends: BaseProcessComponentV2,
  });
